// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__l84GC","messages":"Chat_messages__38ASn","dateDivider":"Chat_dateDivider__33E1l"};